import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButton } from '@bibliocommons/base-buttons';

import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import UgcLikesModal from './UgcLikesModal';

import './UgcLikesButton.scss';

export default function UgcLikesButton({ contentId, count, modalActions, likesActions }) {
  const modalKey = `ugc-likes-modal-${contentId}`;

  const openModal = () => {
    modalActions.openModal(modalKey, { authRequired: false });
  };
  const closeModal = () => modalActions.closeModal(modalKey);

  return (
    <div className="cp-ugc-likes-button">
      <TextButton
        handleClick={openModal}
        className="ugc-likes-modal-button"
        dataKey="ugc-likes-modal-button"
        size="small"
      >
        <FormattedMessage id="existing_likes" values={{ count }} />
      </TextButton>
      <ModalContainer modalKey={modalKey} handleClose={closeModal} size="small">
        <UgcLikesModal contentId={contentId} count={count} likesActions={likesActions} />
      </ModalContainer>
    </div>
  );
}

UgcLikesButton.propTypes = {
  contentId: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  likesActions: PropTypes.objectOf(PropTypes.func).isRequired
};
